const ZIL = ({ ...props }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.2814 9.56208L6.54213 13.3699L14.2814 17.0403V20L3.00618 14.6536L3 11.7402L10.8458 7.88293L3.00618 4.16624V1.20648L14.2814 6.55289V9.56208Z"
      fill="url(#paint0_linear_2746_4465)"
    />
    <path
      d="M3.00635 1.20646L5.98619 0L17.2614 5.34487L14.2815 6.55287L3.00635 1.20646Z"
      fill="url(#paint1_linear_2746_4465)"
    />
    <path
      d="M14.2812 9.56204L17.2611 8.35404V5.34485L14.2812 6.55285V9.56204Z"
      fill="url(#paint2_linear_2746_4465)"
    />
    <path
      d="M14.2812 17.0402V11.1238L17.2611 9.7536V18.792L14.2812 20V17.0402Z"
      fill="url(#paint3_linear_2746_4465)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2746_4465"
        x1="14.2891"
        y1="20.1143"
        x2="4.87534"
        y2="4.25429"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#05707E" />
        <stop offset="0.52" stop-color="#2B9297" />
        <stop offset="1" stop-color="#4DBBBA" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2746_4465"
        x1="3.56401"
        y1="0.920676"
        x2="16.9818"
        y2="5.73106"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#05707E" />
        <stop offset="0.52" stop-color="#2B9297" />
        <stop offset="1" stop-color="#4DBBBA" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_2746_4465"
        x1="14.2812"
        y1="7.45344"
        x2="17.2611"
        y2="7.45344"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#05707E" />
        <stop offset="0.52" stop-color="#2B9297" />
        <stop offset="1" stop-color="#4DBBBA" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_2746_4465"
        x1="15.7349"
        y1="9.10944"
        x2="15.8044"
        y2="19.9722"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#05707E" />
        <stop offset="0.52" stop-color="#2B9297" />
        <stop offset="1" stop-color="#4DBBBA" />
      </linearGradient>
    </defs>
  </svg>
);
export default ZIL;
